module.exports = __webpack_public_path__ + "static/img/right.42e7e2b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.gif
// module id = oXX7
// module chunks = 1